/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery, Divider, Typography, Avatar, ButtonBase } from '@mui/material';
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import { drawerWidth } from 'store/constant';
import { ReactComponent as IconMenu3 } from '../../../assets/images/icons/sidemenu/double arrow 1.svg';
import { ReactComponent as NonSelectedLogoutIcon } from '../../../assets/images/icons/sidemenu/Log-Out line  1.svg';
import { ReactComponent as SelectedLogoutIcon } from '../../../assets/images/icons/sidemenu/Log-Out line  3.svg';
import { useState } from 'react';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, isLoading }) => {
    const theme = useTheme();
    const isTab = useMediaQuery(theme.breakpoints.up('sm'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); //for mobile
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const matchUpLg = useMediaQuery(theme.breakpoints.up('lg'));
    const [hovered, setHovered] = useState(false);

    const handleLogout = async () => {
        try {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('change_password');
            // window.location.href = '/login'; // This will refresh the page completely
            window.location.replace('/login');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    const drawer = (
        <>
            {isTab && (
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: 260,
                            height: '80px !important',
                            padding: '0 16px',
                            paddingLeft: '30px'
                        }}
                    >
                        <div>
                            <LogoSection isLoading={isLoading} />
                        </div>
                        <ButtonBase
                            aria-label="drawertoggle"
                            sx={{ borderRadius: '12px', overflow: 'hidden', marginRight: '10px' }}
                            onClick={drawerToggle}
                        >
                            <IconMenu3 stroke={1.5} sx={{ height: '30px', width: '30px' }} />
                        </ButtonBase>
                    </Box>
                    <Divider className="MarginBottom20px gradient-divider-sidebar" />
                    <Box
                        sx={{
                            height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
                            paddingLeft: '16px',
                            paddingRight: '16px',
                            marginTop: '15px',
                            right: '7px',
                            width: '264px',
                            overflowY: 'hidden', // allow scroll
                            overflowX: 'hidden' // allow scroll
                        }}
                    >
                        <MenuList />
                    </Box>
                    <Divider className="MarginTop2px MarginBottom10px gradient-divider-sidebar" />
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '16px',
                            paddingLeft: '0px',
                            paddingRight: '16px',
                            marginLeft: '20px',
                            paddingBottom: '20px'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                height: '40px',
                                width: '240px',
                                borderRadius: '5px',
                                background: hovered ? '#D9EAFF' : 'transparent'
                            }}
                            onClick={() => handleLogout()}
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                        >
                            <Avatar
                                variant="rounded"
                                sx={{
                                    ...theme.typography.commonAvatar,
                                    ...theme.typography.mediumAvatar,
                                    /* stylelint-disable-next-line order/properties-order */
                                    transition: 'all .2s ease-in-out',
                                    background: 'transparent',
                                    marginLeft: '16px',
                                    marginRight: '10px' // Add margin between icon and text
                                }}
                            >
                                {hovered ? <SelectedLogoutIcon /> : <NonSelectedLogoutIcon />}
                            </Avatar>
                            <Typography
                                sx={{
                                    display: 'flex',
                                    height: '19px',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    flex: '1 0 0',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    lineHeight: 'normal'
                                }}
                                className="OpenSansRegular"
                            >
                                Logout
                            </Typography>
                        </Box>
                    </Box>
                </>
            )}
            {isMobile && ( // for mobile
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: 270,
                            height: '80px !important',
                            padding: '0 16px',
                            paddingLeft: '30px'
                        }}
                    >
                        <div>
                            <LogoSection isLoading={isLoading} />
                        </div>
                        <ButtonBase aria-label="drawertoggle" sx={{ borderRadius: '12px', overflow: 'hidden' }} onClick={drawerToggle}>
                            <IconMenu3 stroke={1.5} size="30px" />
                        </ButtonBase>
                    </Box>
                    <Divider className="MarginTop2px MarginBottom10px gradient-divider-sidebar" />

                    <Box
                        sx={{
                            height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
                            paddingLeft: '16px',
                            paddingRight: '16px',
                            overflowY: 'hidden', // ✅ Disable scroll
                            width: '270px'
                        }}
                    >
                        <MenuList />
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '16px',
                                paddingTop: '5px',
                                cursor: 'pointer',
                                marginBottom: '50px'
                                // marginTop: '90px'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={() => handleLogout()}>
                                <Avatar
                                    variant="rounded"
                                    sx={{
                                        width: '34px',
                                        height: '34px',
                                        fontSize: '1.2rem',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        /* stylelint-disable-next-line order/properties-order */
                                        transition: 'all .2s ease-in-out',
                                        background: 'transparent',
                                        marginX: '4px', // Add margin between icon and text
                                        '&:hover': {
                                            background: theme.palette.secondary.dark,
                                            color: theme.palette.secondary.light
                                        }
                                    }}
                                >
                                    <NonSelectedLogoutIcon />
                                </Avatar>
                                <Typography
                                    sx={{
                                        display: 'flex',
                                        height: '19px',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        flex: '1 0 0',
                                        fontSize: '16px',
                                        lineHeight: 'normal'
                                    }}
                                    className="OpenSansRegular"
                                >
                                    Logout
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </>
            )}
        </>
    );

    return (
        <>
            <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : '0px' }} aria-label="mailbox folders">
                <Box
                    sx={{
                        width: 228,
                        display: 'flex',
                        [theme.breakpoints.down('md')]: {
                            width: 'auto'
                        }
                    }}
                >
                    <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                        <LogoSection isLoading={isLoading} />
                    </Box>
                    <ButtonBase aria-label="drawertoggleavatar1" sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <Avatar
                            variant="rounded"
                            sx={{
                                width: '34px',
                                height: '34px',
                                fontSize: '1.2rem',
                                cursor: 'pointer',
                                borderRadius: '8px',
                                /* stylelint-disable-next-line order/properties-order */
                                transition: 'all .2s ease-in-out',
                                background: theme.palette.secondary.light,
                                color: theme.palette.secondary.dark,
                                '&:hover': {
                                    background: theme.palette.secondary.dark,
                                    color: theme.palette.secondary.light
                                }
                            }}
                            // onClick={handleLeftDrawerToggle}
                            color="inherit"
                        >
                            <IconMenu3 stroke={1.5} size="1.3rem" />
                        </Avatar>
                    </ButtonBase>
                </Box>

                <Drawer
                    // container={container}
                    variant={matchUpLg ? 'persistent' : 'temporary'}
                    anchor="left"
                    open={drawerOpen}
                    onClose={drawerToggle}
                    sx={{
                        '& .MuiDrawer-paper': {
                            overflow: 'hidden', //y lagana h overflow k liye
                            width: drawerWidth,
                            borderRadius: '0px 20px 20px 0px', // border-radius style
                            background: '#FFF', // background style
                            boxShadow: '4px 4px 5px 0px rgba(57, 57, 57, 0.25)', // box-shadow style
                            color: theme.palette.text.primary,
                            borderRight: 'none',
                            top: '0px', // Adjust top positioning
                            [theme.breakpoints.up('md')]: {
                                top: '0px' // Adjust top positioning for md and above
                            }
                        }
                    }}
                    // ModalProps={{ keepMounted: true }}
                    color="inherit"
                >
                    {isLoading === true ? drawer : drawer}
                </Drawer>
            </Box>
        </>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    isLoading: PropTypes.bool
};

export default Sidebar;
